module.exports = __webpack_public_path__ + "amcharts/images/dragIconRectSmallBlack.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRectSmallBlack.png
// module id = 240
// module chunks = 0